import axios, { AxiosResponse } from 'axios';

import { ETypZadosti } from 'services/akcionar/emise/zruseniZadosti';

import { EStav } from 'enums/isin/eStav';
import { EDruhCp } from 'enums/isin/udaje/druhCp';

export interface IPodaneZadosti {
    id: number;
    ic: string;
    nazev: string;
    formular: string;
    stat: string;
    stav: string;
    datum: string;
    typzadosti?: ETypZadosti;
    druhcp?: EDruhCp;
}

export interface IZadostiTable {
    offset: number;
    limit: number;
    count: number;
    order: string;
    zadosti?: IPodaneZadosti[];
}

const podaneZadostiApi = (
    order: string,
    ico: string,
    formular: string,
    limit: number,
    offset: number,
    stav?: EStav
) => {
    return axios({
        method: 'GET',
        url: '/ISIN/Zadosti',
        params: {
            // order: order ? order + ':id:desc' : 'id:desc',
            order,
            ic: ico,
            formular,
            limit,
            offset,
            ...(stav && {
                stav: stav
            })
        }
    }).then((resp: AxiosResponse<IZadostiTable>) => resp.data);
};

export default podaneZadostiApi;
